import React from 'react';
import PropTypes from 'prop-types';

import ExternalLinkSvg from 'pages/common/components/svgs/ExternalLinkSvg';
import { formatAverageRating } from 'pages/common/helpers/common-helpers';
import { VisuallyHidden } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import {
  Card,
  HeadingWrapper,
  Heading,
  BodyWrapper,
  Rating,
  ReviewsCount,
  BottomRow,
  LinkWrapper,
} from './styled-components';

function ReviewSourceCard({
  link,
  source,
  averageRating,
  reviewCount,
  borderColor,
  backgroundColor,
  headingColor,
  icon,
}) {
  const formattedAverageRating = formatAverageRating(averageRating);

  return (
    <Card>
      <LinkWrapper as={link ? 'a' : 'div'} href={link} target="_blank">
        <HeadingWrapper
          borderColor={borderColor}
          backgroundColor={backgroundColor}
          color={headingColor}
        >
          {icon}
          <Heading aria-label={`${source} reviews`}>{source}</Heading>
        </HeadingWrapper>
        <VisuallyHidden>
          {reviewCount
            ? `${formattedAverageRating} out of 5 stars from ${reviewCount} reviews`
            : 'No reviews'}
        </VisuallyHidden>
        <BodyWrapper aria-hidden>
          <Rating>{averageRating ? `${formattedAverageRating}/5` : '-'}</Rating>
          <BottomRow>
            <ReviewsCount>
              {reviewCount ? `${reviewCount} reviews` : 'No reviews'}
            </ReviewsCount>
            {link && <ExternalLinkSvg color={colors.gray8} height="10" />}
          </BottomRow>
        </BodyWrapper>
      </LinkWrapper>
    </Card>
  );
}

ReviewSourceCard.propTypes = {
  link: PropTypes.string,
  averageRating: PropTypes.number,
  reviewCount: PropTypes.number,
  source: PropTypes.string.isRequired,
  borderColor: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  headingColor: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
};

export default ReviewSourceCard;
